"use client";

import { c as _c } from "react/compiler-runtime";
import ProgressChart from "@/components/levels/ProgressChart";
import TableOfLevels from "@/components/levels/TableOfLevels";
import { useSetTitle } from "@/contexts/TitleContext";
export default function LevelsClient() {
  const $ = _c(3);
  useSetTitle("Levels | Network");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1 className="tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-0">Levels</h1>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProgressChart />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tailwind-scope"><div className="tw-pt-12 tw-pb-12"><div className="tw-px-2 lg:tw-px-6 xl:tw-px-8 tw-mx-auto">{t0}<div className="tw-my-6 tw-flex tw-flex-col">{t1}<ul className="tw-ml-4 tw-pl-0"><li className="tw-text-justify tw-mb-0 tw-mt-2 tw-font-normal tw-text-base tw-text-iron-100">Levels are our integrated metric of TDH and Rep.</li><li className="tw-text-justify tw-mb-0 tw-mt-2 tw-font-normal tw-text-base tw-text-iron-100">TDH and rep are added together and the level is determined by the table below. It is our most integrated measure of trust in our ecosystem.</li><li className="tw-text-justify tw-mb-0 tw-mt-2 tw-font-normal tw-text-base tw-text-iron-100">Levels start at zero and are currently capped at 100 (for 25,000,000 TDH).</li><li className="tw-text-justify tw-mb-0 tw-mt-2 tw-font-normal tw-text-base tw-text-iron-100">Levels are determined by the table below.</li><li className="tw-text-justify tw-mb-0 tw-mt-2 tw-font-normal tw-text-base tw-text-iron-100">As with all metrics, they may be adjusted to better meet their objectives.</li></ul></div><TableOfLevels /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}